import { boot } from 'quasar/wrappers'
import createPersistedState from 'vuex-persistedstate'

export default boot(({ store, urlPath }) => {
  const comps = urlPath.split('/')

  window.setTimeout(() => {
    createPersistedState({
      key: `root-${comps[1]}`,
      paths: ['auth'],
    })(store)
  }, 0)
})
